import Reset from "./Set";
export default Reset;
